import React from 'react';
import {
  AboutBanner,
  // AboutCommunity,
  // AboutHistory,
  // AboutTeam,
  AboutValues
} from '../../sections';

const AboutContainer = () => {
  return (
    <>
      <AboutBanner />
      <AboutValues />
      {/* <AboutHistory />
      <AboutTeam /> */}
      {/* <AboutCommunity /> */}
    </>
  );
};

export default AboutContainer;
